import { utcDate, userDate } from 'owa-datetime';

/**
 * Tests whether or not the string can make a valid owaDate object
 * @param dateTimeString the datetime string to be
 */
export default function tryCreateOwaDate(
    dateTimeString: string,
    errorHandler?: (e: Error) => void
): boolean {
    if (dateTimeString) {
        try {
            return !!utcDate(dateTimeString) || !!userDate(dateTimeString);
        } catch (e) {
            errorHandler && errorHandler(e);
        }
    }
    return false;
}
